import { render, staticRenderFns } from "./goodsViceSetsList.vue?vue&type=template&id=4c25395c&scoped=true&"
import script from "./goodsViceSetsList.vue?vue&type=script&lang=js&"
export * from "./goodsViceSetsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsViceSetsList.vue?vue&type=style&index=0&id=4c25395c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25395c",
  null
  
)

component.options.__file = "goodsViceSetsList.vue"
export default component.exports